<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <div v-if="loading">Carregando leads...</div>
        <material-card
          color="success"
          title="Leads"
          text="Leads cadastrados na plataforma"
          v-if="!loading"
        >
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
          <v-layout>
            <v-flex md12 sm6 lg4> </v-flex>
            <v-flex md12 sm6 lg8>
              <v-layout>
                <!--
                    <v-flex md12 sm4 lg4>
                        <v-icon >
                        access_time
                        </v-icon>&nbsp;Aguardando conta
                    </v-flex>
                    <v-flex md12 sm4 lg4>
                        <v-icon >
                        send
                        </v-icon>&nbsp;Proposta Enviada
                    </v-flex>
                    <v-flex md12 sm4 lg4>
                        <v-icon color="blue">
                        done
                        </v-icon>&nbsp;Contrato Assinado
                    </v-flex>
                    -->
              </v-layout>
            </v-flex>
          </v-layout>
          <v-progress-linear
            v-if="loading"
            height="2"
            v-slot:loading
            color="cyan"
            indeterminate
          ></v-progress-linear>
          <v-data-table
            :headers="headers"
            :items="leads"
            :search="search"
            :loading="loading"
            no-data-text="Não há leads cadastrados"
            rows-per-page-text="Linhas por página"
            :pagination.sync="pagination"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.item.created_at | formatDate }}</td>
              <td>
                {{
                  item.item.signedcontract_at
                    ? item.item.signedcontract_at
                    : item.item.updated_at | formatDate
                }}
              </td>
              <td>{{ item.item.name }}</td>
              <td>{{ item.item.email }}</td>
              <td>{{ item.item.phone }}</td>
              <!-- <td class="text-xs-right">{{ item.item.state || '' }}</td> -->
              <td>{{ item.item.utm_campaign }}</td>
              <td class="text-xs-right">
                {{ item.item.average_consumption || 0 }}
              </td>
              <td>{{ item.item.concessionaria }}</td>
              <td>{{ item.item.termouso }}</td>
              <!-- <td class="text-xs-right">
                        <img src="@/assets/icons/bill.png" alt="conta" v-if="item.item.bills">
                        <v-badge overlap color="cyan" v-if="item.item.emailconta && item.item.emailconta > 0">
                        <template v-slot:badge>
                            <span>{{item.item.emailconta}}</span>
                        </template>
                        <v-icon v-if="!item.item.bills" @click="enviarEmail(item, process.env.VUE_APP_SENDGRID_TEMPLATE_CONTAPENDENTE)">mail</v-icon>
                        </v-badge>
                        <v-icon v-if="!item.item.bills && (!item.item.emailconta || item.item.emailconta === 0)" @click="enviarEmail(item)">mail</v-icon>
                    </td> -->
              <!-- <td>
                        <template>
                        <v-icon 
                            v-if="item.item.step <= 1"
                            @click="proposta(item, 2)"
                        >
                            access_time
                        </v-icon>
                        <v-icon 
                            v-if="item.item.step === 2"
                            @click="proposta(item, 3)"
                        >
                            send
                        </v-icon>
                        <v-icon 
                            color="blue"
                            v-if="item.item.step === 3"
                        >
                            done
                        </v-icon>
                        </template>
                    </td> -->
              <!--<td><v-icon @click="getLeadDetail(item.item.email)">visibility</v-icon></td>-->
              <td>
                <v-icon @click.prevent="leadSelected(item.item)"
                  >visibility</v-icon
                >
              </td>
            </template>
            <v-alert
              v-slot:no-results
              :value="true"
              color="error"
              icon="warning"
            >
              Sua busca para "{{ search }}" não retornou resultados.
            </v-alert>
            <template v-slot:pageText="items">
              Linhas {{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }}
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import moment from "moment";
import { eventBus } from "../../main";

export default {
  props: ["leads"],
  data: () => ({
    search: "",
    loading: false,
    headers: [
      {
        sortable: true,
        text: "Criado",
        value: "item.item.created_at",
      },
      {
        sortable: true,
        text: "Atualizado",
        value: "item.item.updated_at",
      },
      {
        sortable: true,
        text: "Name",
        value: "item.item.name",
      },
      {
        sortable: true,
        text: "E-mail",
        value: "item.item.email",
      },
      {
        sortable: false,
        text: "Telefone",
        value: "item.item.phone",
      },
      {
        sortable: true,
        text: "Campanha",
        value: "item.item.utm_campaign",
      },
      {
        sortable: true,
        text: "Consumo Médio",
        value: "item.item.average_consumption",
        align: "right",
      },
      {
        text: "Concessionaria",
        sortable: false,
        name: "concessionaria",
      },
      {
        text: "Termo de uso",
        sortable: false,
        name: "termouso",
      },
      {
        text: "   ",
        sortable: false,
        name: "edit",
      },
    ],
    pagination: {
      sortBy: "item.item.updated_at",
      rowsPerPage: 10,
    },
  }),
  filters: {
    formatDate: function (value) {
      if (!value) return "";
      if (typeof value === "string") {
        return moment(value).format("DD/MM/YYYY");
      }
      let timestamp = value; // firebase data
      // let myDate = new Date(timestamp._seconds * 1000) // date object
      let myDate = timestamp.toDate(); // date object

      return moment(myDate.toISOString().substr(0, 10)).format("DD/MM/YYYY");
    },
  },
  methods: {
    leadSelected(lead) {
      eventBus.$emit("leadSelected", lead);
    },
  },
};
</script>
